import React, { CSSProperties } from "react";
import { Avatar, AvatarProps } from "@progress/kendo-react-layout";

interface AvatarComponentProps {
  image?: string;
  title?: string;
  initials?: string;
  size?: number;
  rounded?: AvatarProps["rounded"];
  style?: CSSProperties;
  className?: string;
}

const AvatarComponent: React.FC<AvatarComponentProps> = ({
  image,
  title,
  initials,
  size = 45,
  rounded = "full",
  style,
  className = "",
}) => {
  return (
    <Avatar
      style={{
        width: size,
        height: size,
        flexBasis: size,
        ...style,
      }}
      rounded={rounded}
      type={"image"}
      className={className}
    >
      {image ? (
        <img
          src={image}
          alt={title || "Image"}
          onClick={() => window.open(image)}
          style={{ cursor: "pointer" }}
          width={200}
          height={200}
        />
      ) : (
        <div
          style={{
            width: size,
            height: size,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          {initials || (title ? title.slice(0, 1).toUpperCase() : "")}
        </div>
      )}
    </Avatar>
  );
};

export default AvatarComponent;
